import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"
import auth from "@/store/modules/auth";
import provs from "@/store/modules/provs";
import hist from "@/store/modules/hist";
import payinfo from "@/store/modules/payinfo";
import temp from "@/store/modules/temp";

Vue.use(Vuex)

// eslint-disable-next-line no-undef
axios.defaults.baseURL = process.env.VUE_APP_API_URL

axios.defaults.headers.common['X-Login'] = getPoint();
axios.defaults.headers.common['X-Token'] = getToken();
axios.defaults.timeout = 60000; // (60 секунд)

function getPoint() {
  return localStorage.getItem('point') || '';
}
function getToken() {
  return localStorage.getItem('token') || '';
}

export const store = new Vuex.Store({
  modules: {
    auth,
    provs,
    hist,
    payinfo,
    temp
  }
})
